<!-- ======= Hero Section ======= -->
<section class="login-page-section-top">
    <div class="container">
        <div class="row">
            <div class="col-md-12 size-img back-img">
                <div class="effect-cover">
                    <h3 class="txt-advert animated fadeInUp">Refer & Earn </h3>
                    <p class="txt-advert-sub animated">Welcome to our Refer & Earn program! We believe that our loyal customers are our best advocates, and we want to reward you for spreading the word about our platform. It's a win-win – you get rewarded, and your friends or contacts get to experience the benefits of our services.</p>
                </div>
            </div>
        </div>
    </div>
    <div *ngFor="let banner of bannerImageList " class="swiper-slide zoom-effect-container banner-image-div">
        <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
            <div class="headings image-card">
                <img [src]="banner.banner_image_src" class="product-image" alt="banner" />
                <div class="slider-inner-div">
                    <div class="container">
                        <div class="main-heading-banner">
                            <!-- <div class="headings-section-banner">
        <h4 class="tracking-in-contract">CREATIVE</h4>
        <div class="main-heading tracking-in-contract new">
            WEB DESIGN.
        </div>
    </div> -->
                            <div class="sldier-bottom-section"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mobile_version-backbutton">
        <a class="mobile-header" onclick="history.back()">
          <i class="bx bx-chevron-left" style="color: #fff; font-size: 1.6em;"></i> Back </a>
      </div>
</section>

<section class="Wallet-secrion mb-0 pb-0 frist-div">
    <div class="container">
        <div class="row m-0">
            <div class="col-md-12 wallet-div">
                <div class="wallet-heading">
                    <h1>
                        Refer a Friend
                    </h1>
                    <p class="para-text">Don't miss out on the opportunity to earn rewards while sharing the benefits of our platform with your network. Start referring today and be a part of our growing community.</p>
                </div>
                <div class="col-md-12">
                    <!-- <div class="refreal-div">
                        <div class="form">
                          <input type="text" #inputRef value="https://www.tplsport.com/{{this.referralcode}}">
                          
                        </div>
                        <div class="share-button">
                          <a href="{{shareurl}}" target="_blank">
                            <a href="{{shareurl}}" target="_blank">  <button>Invite <span><i class='bx bx-share-alt'></i></span> </button></a>
                          </a>
                        </div>
                       
                      </div>
                      <button (click)="copyInputValue()">Copy Input Value <span><i class='bx bx-copy'></i></span></button> -->
                      
                    <div class="refreal-div">
                        <div class="form">
                            <input type="text" value="https://www.tplsport.com/{{this.referralcode}}">
                        </div>
                        <div class="share-button">
                          <a href="{{shareurl}}" target="_blank">  <button>Invite <span><i class='bx bx-share-alt'></i></span> </button></a>
                        </div>
                    </div>
                    
                </div>
            </div>

           
        </div>
    </div>
</section>            



<section class="Wallet-secrion second-div pt-0">
    <div class="container">
        <div class="row m-0">
            <div class="col-md-12 wallet-div">
               
                <div class="balance-list">
                    <div class="tpls-cash-and-coins">
                        <div class="top-div">
                            <div class="icon">
                                <i class='bx bx-gift' ></i>
                            </div>
                            <div class="title">
                                <h4>Total Reward Earn</h4>
                                <h6>₹{{totalAvailableCash}}</h6>
                            </div>
                        </div>
                        <div class=" redemption">
                            <button class="redeem" (click)="transferAmountToBank(this.userId)">
                                Claim <i class='bx bx-up-arrow-alt'></i>
                            </button>
                        </div>
                    
                    </div>
                    <div class="tpls-cash-and-coins">
                        <div class="top-div">
                            <div class="icon">
                                <i class='bx bx-user-plus' ></i>
                            </div>
                            <div class="title">
                                <h4>Total Referee</h4>
                                <h6>{{totalReferee}}</h6>
                            </div>
                        </div>
                        <div class=" redemption">
                            <button class="redeem btn-primery" (click)="viewReferreList()">
                                View <i class='bx bx-show-alt' ></i>
                            </button>
                        </div>
                    
                    </div>
                   
                </div>
               
               
                <!-- <div class="balance-list">
                    <div class="tpls-cash-and-coins">
                        <div class="title">
                            <h4>Cash</h4>
                            <h6>{{totalAvailableCash}}</h6>
                        </div>
                        <div class="add-button">
                            <button (click)="addCash()">Add More Cash <span><i class='bx bx-plus'></i></span></button>
                        </div>
                    </div>
                    <div class="pipe"></div>
                    <div class="tpls-cash-and-coins">
                        <div class="title">
                            <h4>Coins</h4>
                            <h6>{{totalAvailableCoins}}</h6>
                        </div>
                        <div class="add-button"> -->
                            <!-- <button (click)="addCoin()">Use Coins <span><i class='bx bx-plus'></i></span></button> -->
                        <!-- </div>
                    </div>
                </div> -->
               
                <div class=" col-md-12 transation-history">
                    <div class="tableheader-heading">
                        <h2>
                            History
                        </h2>
                    </div>
                    <div class="table-div w-100">
                        <p-table #dt [value]="walletlist" [paginator]="true" [rows]="10" [lazy]="true" appendTo=""
                            [autoLayout]="true" (onLazyLoad)="loadWalletHistory($event)" [totalRecords]="totalRecords"
                            [loading]="loading" [rowsPerPageOptions]="paginationOption">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="display: table-cell!important;" pSortableColumn="id"
                                        class="transactionId">Transaction ID</th>
                                    <th style="display: table-cell!important;" pSortableColumn="description"
                                        class="transactiodescription">Description</th>
                                    <th style="display: table-cell!important;" pSortableColumn="created_at"
                                        class="date">Date</th>
                                    <th style="display: table-cell!important;" pSortableColumn="email"
                                        class="amount-div">Amount</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-wallet let-i="rowIndex">
                                <tr class="p-selectable-row">
                                    <td class="transactionId">
                                        <!-- {{wallet.id}} -->
                                        {{ i + 1 }}
                                    </td>
                                    <td class="transactiodescription">
                                        {{wallet.description}}
                                    </td>
                                    <td class="date">
                                        {{wallet.created_at | date: 'dd MMM, yyyy'}}
                                    </td>
                                    <td *ngIf="wallet.action=='ADD'" class="amount-div">
                                        <i class='bx bx-plus'></i> {{wallet.amount}} {{wallet.wallettype | lowercase }}
                                    </td>
                                    <td *ngIf="wallet.action=='SUBTRACT'" class="amount-div">
                                        <i class='bx bx-minus'></i> {{wallet.amount}} {{wallet.wallettype | lowercase }}
                                    </td>
                                    <!-- <td *ngIf="wallet.coins!=0">                                    
                                    <div class="debit" *ngIf="wallet.action=='ADD'">
                                        <i class='bx bx-plus'></i> {{wallet.coins}} {{wallet.wallettype | lowercase }}<span></span>
                                    </div>
                                    <div class="credits" *ngIf="wallet.action=='SUBTRACT'">
                                        <i class='bx bx-minus'></i> {{wallet.coins}} {{wallet.wallettype | lowercase}} <span></span>
                                    </div>
                                    
                                </td>
                                <td *ngIf="wallet.cash!=0">
                                    <div class="debit" *ngIf="wallet.action=='ADD'">
                                        <i class='bx bx-plus'></i> {{wallet.cash}} {{wallet.wallettype | lowercase}}<span></span>
                                    </div>
                                    <div class="credits" *ngIf="wallet.action=='SUBTRACT'">
                                        <i class='bx bx-minus'></i> {{wallet.cash}} {{wallet.wallettype | lowercase}} <span></span>
                                    </div>
                                </td> -->
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<p-dialog class="add-amont-popup" [(visible)]="addCashmodal" [modal]="true" [style]="{width: '500px'}" header="Add Cash"
    [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
    (onHide)="cashclose()">

    <form [formGroup]="addCashForm" *ngIf="this.addCashForm">
        <div class="p-fluid p-formgrid p-grid">
            <div class="wallet-icons">
                <div class="icon"><i class="bx bx-wallet-alt"></i></div>
                <h1>Enter Amount</h1>
            </div>
            <div class="p-field p-col-12">
                <!-- <label for="amount">Amount<span class="mandatory-fields">*</span></label> -->
                <input formControlName="amount" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.amount.errors }" placeholder="₹ 0">
                <div *ngIf="submitted && f.amount.errors" class="invalid-feedback">
                    <div *ngIf="f.amount.errors.required">Amount is required</div>
                    <div *ngIf="!f.amount.errors.required && f.amount.errors">Only Numbers allowed</div>
                </div>
            </div>
            <div class="p-field p-col-12 msg-div">
                <p-messages severity="info">
                    <ng-template pTemplate>
                       <i class="pi pi-info-circle"></i>
                       <div class="ml-2">Please Note: For iPhone users - To make a payment using Gpay, select "Others" option in the UPI menu and manually enter your UPI ID.</div>
                    </ng-template>
                </p-messages>
               
            </div>
        </div>
        <div class="col-md-12 text-center">

            <button type="button" (click)="onCashSubmit()" pButton label="Add To Wallet"
                class="p-button-primery save-btn p-mr-0" style="width: auto"></button>
        </div>
    </form>
</p-dialog>
<p-dialog [(visible)]="showThankyouModal" [modal]="true" [style]="{width: '500'}" header="Thank You"
    [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
    (onHide)="closeThankyou()">
    <div class="col-md-12">
        Amount added to Wallet Successfully.
    </div>
</p-dialog>

<p-dialog class="add-amont-popup" [(visible)]="addCoinmodal" [modal]="true" [style]="{width: '500px'}"
    header="Add Coins" [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false" (onHide)="coinclose()">
    <!-- <form [formGroup]="addCoinForm" *ngIf="this.addCoinForm">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12">
                <label for="amount">Amount<span class="mandatory-fields">*</span></label>
                <input formControlName="amount" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': coinsubmitted && f1.amount.errors }">
                <div *ngIf="coinsubmitted && f1.amount.errors" class="invalid-feedback">
                    <div *ngIf="f1.amount.errors.required">Amount is required</div>
                    <div *ngIf="!f1.amount.errors.required && f1.amount.errors">Only Numbers allowed</div>
                </div>
            </div>
            <div class="p-field p-col-12">Note: 1 Cash equal to 10 Coins</div>
        </div>
        <button type="button" (click)="onCoinSubmit()" pButton icon="pi pi-check" label="Checkout"
            class="p-button-success save-btn p-mr-0" style="width: auto"></button>
    </form> -->

    <form [formGroup]="addCoinForm" *ngIf="this.addCoinForm">
        <div class="p-fluid p-formgrid p-grid">
            <div class="wallet-icons">
                <div class="icon"><i class="bx bx-wallet-alt"></i></div>
                <h1>Enter Amount</h1>
            </div>
            <div class="p-field p-col-12 mb-0">
                <!-- <label for="amount">Amount<span class="mandatory-fields">*</span></label> -->
                <input formControlName="amount" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': coinsubmitted && f1.amount.errors }" placeholder="₹ 0">
                <div *ngIf="coinsubmitted && f1.amount.errors" class="invalid-feedback">
                    <div *ngIf="f1.amount.errors.required">Amount is required</div>
                    <div *ngIf="!f1.amount.errors.required && f1.amount.errors">Only Numbers allowed</div>
                </div>
            </div>
            <div class="p-field p-col-12  text-center" style="color:#000;">Note: 1 Cash equal to 10 Coins</div>
        </div>
        <div class="col-md-12 text-center">

            <button type="button" (click)="onCoinSubmit()" pButton label="Add To Wallet"
                class="p-button-primery save-btn p-mr-0" style="width: auto"></button>
        </div>
    </form>

</p-dialog>